export enum HClientErrors {
  failed = 'No fue posible autorizar al usuario.',
  canceled = 'Se ha cancelado el proceso de verificación.',
}
